export default __webpack_public_path__ + "static/media/downArrow.7b18aa2e.svg";